import { Component, signal, DestroyRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CrossComponentService } from '../../../core/services/cross-component.service';
import { RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserHttpService } from '../../../core/services/user.http.service';
import { BootstrapToastService } from '../../../core/services/bootstrap-toast.service';
import { IntlTelInputDirective, IntlTelInputOptions } from '../../../core/directives/intl-tel-input.directive';

@Component({
  selector: 'app-home-popup',
  imports: [ReactiveFormsModule, RouterLink, IntlTelInputDirective],
  templateUrl: './home-popup.html',
  styleUrl: './home-popup.scss',
})
export class HomePopup {

  @ViewChild(IntlTelInputDirective)
  telInput?: IntlTelInputDirective;

  homeForm!: FormGroup;
  done = signal<boolean>(false);
  isSending = signal<boolean>(false);

  itiOptions: IntlTelInputOptions = {
    initialCountry: 'us',
    countryOrder: ['us', 'gb'],
    separateDialCode: true,
    loadUtils: () => import('intl-tel-input/utils'),
  };

  constructor(
    private crossComponentService: CrossComponentService,
    private fb: FormBuilder,
    private destroyRef: DestroyRef,
    private userHttpService: UserHttpService,
    private toast: BootstrapToastService
  ) {
    this.homeForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: [undefined],
      company: [''],
      sample_report_type: ['sample_full']
    });
  }

  onSubmit() {
    if (this.homeForm.invalid) {
      this.homeForm.markAllAsTouched();
      return
    }
    this.isSending.set(true);

    const formValue = this.homeForm.value;
    const phone = this.telInput?.getInternationalNumber() || formValue.phone || '';

    this.userHttpService.sampleReportRequest({ ...formValue, phone }).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: () => {
        this.done.set(true);
        this.isSending.set(false);
        this.toast.show('The illustrative report has been sent to your email.', 'success', 'Illustrative Report');
        setTimeout(() => {
          this.closePopup();
        }, 7000);
      },
      error: (err: any) => {
        console.error('Error submitting form', err);
        this.isSending.set(false);
        this.toast.show(err?.error?.message || 'Could not send the illustrative report.', 'danger', 'Illustrative Report');
      }
    });

  }

  closePopup() {
    this.crossComponentService.closeHomePopup();
    localStorage.setItem('homePopupDismissedAt', String(Date.now()));
  }
}
